import { Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[phx-carousel-item]',
  host: {
    // add a class to projected items so global styles can target them
    'class': 'phx-carousel-item'
  }
})
export class PhxCarouselItemDirective {
  constructor(public el: ElementRef) {}
}
